module.exports = __webpack_public_path__ + "static/media/YF03_1.909f4ec4.jpg";